import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import {Lazyload,Sticky} from 'vant';

import 'vant/es/tab/style/index';
import 'vant/es/tabs/style/index';
import 'vant/es/icon/style/index';
import 'vant/es/nav-bar/style/index'
const app = createApp(App);
app.use(router);
app.use(Lazyload);
app.use(Sticky);
app.mount('#app')
